import React from 'react';
import { ArmchairIcon, Building2Icon, UsersIcon, GraduationCapIcon, LaptopIcon, ClockIcon } from 'lucide-react';
const rooms = [{
  title: 'Private practice',
  body: 'Individual sessions of 30, 50 or 80 minutes, with a session formula in every volume.',
  Icon: ArmchairIcon
}, {
  title: 'Counseling centers & clinics',
  body: 'Bonus 5 shows where a Gestalt experiment fits in short, person-centered or CBT-informed sessions.',
  Icon: Building2Icon
}, {
  title: 'Therapy groups',
  body: 'Volume 6: field reads, interpersonal rounds and 90- or 120-minute group plans.',
  Icon: UsersIcon
}, {
  title: 'Training groups',
  body: 'Triads, fishbowl demos and here-and-now supervision rounds, with consent built in.',
  Icon: GraduationCapIcon
}, {
  title: 'Online sessions',
  body: 'Every volume has a page on adapting its experiments to video: framing, privacy, closing.',
  Icon: LaptopIcon
}, {
  title: 'Busy weeks',
  body: 'The Printable Card Deck and the Pre-Session Routine take minutes, not hours.',
  Icon: ClockIcon
}];
export function UseCases() {
  return <section aria-labelledby="rooms-heading" className="w-full bg-sand" data-id="element-352" data-mp="2wr7le2bxblw1">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-353" data-mp="2iv3rka4ypfk3">
        <div className="text-center" data-id="element-354" data-mp="2mukyz93y8mrw">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-355" data-mp="2mvmk66eoipnc">
            Who it’s for
          </p>
          <h2 id="rooms-heading" className="chalk-underline mt-3 font-display text-[28px] text-sage sm:text-5xl" data-id="element-356" data-mp="3an1k5sizguvf">
            Built for the rooms you work in
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-357" data-mp="35tyw1zwz6dmm">
            For Gestalt therapists, Gestalt-trained and Gestalt-informed
            counselors and psychotherapists, and trainees working alongside
            supervision.
          </p>
        </div>

        <ul className="mt-9 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-358" data-mp="26zyk7yrtidq">
          {rooms.map(({
          title,
          body,
          Icon
        }) => <li key={title} className="flex items-start gap-3 rounded-2xl border border-sand-dark bg-cream p-5" data-id="element-359" data-mp="7zah82sugcyw">
              <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-sage text-cream" data-id="element-360" data-mp="2ymh8rmn0lsj">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-361" data-mp="3u8l8bcxvvqtu" />
              </span>
              <span data-id="element-362" data-mp="3p8ytiz2eq2ix">
                <span className="block font-display text-lg leading-snug text-sage" data-id="element-363" data-mp="3p9i9wbcesiuu">
                  {title}
                </span>
                <span className="mt-1 block text-sm text-ink-soft" data-id="element-364" data-mp="3gekix9stng65">{body}</span>
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}